import CopyButton from './CopyButton'
import type { Platform } from '../../types'
import clsx from 'clsx'

interface PlatformTabProps {
  platform: Platform
  content: string
}

export default function PlatformTab({ platform, content }: PlatformTabProps) {
  const charCount = content.length
  const isTwitter = platform === 'twitter'
  const isOverLimit = isTwitter && charCount > 280

  return (
    <div
      id={`panel-${platform}`}
      role="tabpanel"
      className="space-y-4"
    >
      {/* Content */}
      <div
        className={clsx(
          'whitespace-pre-wrap text-[var(--bbs-text-primary)]',
          platform === 'forum' && 'font-mono text-sm'
        )}
      >
        {content}
      </div>

      {/* Footer: char count + copy button */}
      <div
        className="flex items-center justify-between border-t border-[var(--bbs-color-border)]"
        style={{ paddingTop: 'var(--bbs-spacing-md)' }}
      >
        {/* Character count for Twitter */}
        {isTwitter && (
          <div className="flex items-center gap-2">
            <div
              className={clsx(
                'text-sm font-medium',
                !isOverLimit && 'text-green-600',
                isOverLimit && 'text-red-500'
              )}
            >
              {charCount} / 280
            </div>

            {/* Visual progress bar */}
            <div className="w-24 h-1.5 bg-[var(--luxury-glass-neutral)] rounded-full overflow-hidden">
              <div
                className={clsx(
                  'h-full rounded-full transition-all',
                  !isOverLimit && 'bg-green-500',
                  isOverLimit && 'bg-red-500'
                )}
                style={{ width: `${Math.min((charCount / 280) * 100, 100)}%` }}
              />
            </div>

            {isOverLimit && (
              <span className="text-xs text-red-500">
                {charCount - 280} over limit
              </span>
            )}
          </div>
        )}

        {!isTwitter && (
          <span className="text-xs text-[var(--bbs-text-tertiary)]">
            {charCount} characters
          </span>
        )}

        <CopyButton text={content} platform={platform} />
      </div>
    </div>
  )
}
